import Vue from 'vue'
import Router from 'vue-router'

// 按需加载书写形式
const Index = () => import('@/views/index.vue');
const Start = () => import('@/views/start.vue');
const Account = () => import('@/views/account/index.vue');
const SignUp = () => import('@/views/newLogin/SignUpPage.vue');
const Verify = () => import('@/views/newLogin/VerificationPage.vue');
Vue.use(Router)
let routes =  [
    {
        path: '/',
        name: '',
        redirect: {
            name: 'signUp'
        }
    },
    {
        path: '/',
        name: '',
        component: Index,
        children: [{
            path: 'start',
            name: 'start',
            component: Start,
            meta:{
                title:'TVU Search Registration -- Start'
            }
        },
        {
            path: 'account',
            name: 'home',
            component: Account,
            meta:{
                title:'TVU Search Registration -- Account'
            }
        },
        {
            path: 'signUp',
            name: 'signUp',
            component: SignUp,
            meta: {
                title:'TVU Search Registration -- Account'
            }
        },
        {
            path: 'verify',
            name: 'verify',
            component: Verify,
            meta: {
                title:'TVU Search Registration -- Account'
            }
        }]
    },
]
const router =  new Router({
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title; //修改网页标题
    }
    next();
})

export default router
